import * as types from "../ActionType";

const initState = {
    projects: [],
    loadingProjects: true
}

const ProjectsReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_PROJECT:
            return { ...state, loadingProjects: true }
        case types.GET_PROJECTS:
            return { ...state, projects: action.payload, loadingProjects: false }
        case types.DELETE_PROJECT:
            return { ...state}
        case types.EDIT_PROJECT:
            return { ...state, loadingProjects: true }
        default:
            return state;
    }
};

export default ProjectsReducer;
